import MatchingSelectSchools from './MatchingSelectSchools.page';

export default MatchingSelectSchools;
